import { postData } from '../utils/ajax-utils';
import { BtnLoadingResetEvent, BtnLoadingWaitEvent } from './btn-loading';
import { ModalHTMLElement } from './modal';
import { PhoneOtpModule, PhoneOtpModuleHTMLElement } from './phone-otp-module';

export function initPartnerCredentialsAction() : void {
    document.querySelectorAll<ModalHTMLElement>('.js-my-partners-otp-modal').forEach($otpModal => {
        const modalId = $otpModal.getAttribute('id');
        const $buttons = document.querySelectorAll<HTMLButtonElement>(`.js-my-partners-open-otp-button[data-modal-id="${modalId}"]`);

        $buttons.forEach($button => {
            const $container = $button.closest<HTMLElement>('.js-my-partner');
            const partnerName = $button.dataset.partnerName ?? '';
            const $credentialsContainer = document.querySelector<HTMLElement>(`.js-my-partners-credentials-container[data-partner-name="${partnerName}"]`);

            if ($container && $credentialsContainer) {
                new PartnersOtp($container, partnerName, $otpModal, $button, $credentialsContainer);
            }
        });
    });
}

class PartnersOtp {
    $container: HTMLElement;
    partnerName: string = '';
    $otpModal: ModalHTMLElement;
    $button: HTMLButtonElement;
    $credentialsContainer: HTMLElement;
    $loginContainer: HTMLElement|null;
    $passwordContainer: HTMLElement|null;
    $errorsContainer: HTMLUListElement|null;

    constructor($container: HTMLElement, partnerName: string, $otpModal: ModalHTMLElement, $button: HTMLButtonElement, $credentialsContainer: HTMLElement) {
        this.$container = $container;
        this.partnerName = partnerName;
        this.$otpModal = $otpModal;
        this.$button = $button;
        this.$credentialsContainer = $credentialsContainer;
        this.$loginContainer = $credentialsContainer.querySelector<HTMLElement>('.js-my-partners-credentials-login');
        this.$passwordContainer = $credentialsContainer.querySelector<HTMLElement>('.js-my-partners-credentials-password');
        this.$errorsContainer = this.$container.querySelector<HTMLUListElement>('.js-my-partners-credentials-error');

        const $phoneOtpModule = document.querySelector<PhoneOtpModuleHTMLElement>('.js-my-partners-otp-module');
        $button.addEventListener('click', evt => {
            evt.preventDefault();
            document.dispatchEvent(new CustomEvent('open_modal', { detail: { $modal: this.$otpModal } }));

            // Tous les partenaires se partagent le même phoneOtpModule.
            // On change l'ID du module pour pouvoir savoir pour quel partenaire on fait une action
            if ($phoneOtpModule) {
                $phoneOtpModule.id = partnerName;
            }
        });

        if ($phoneOtpModule) {
            // Si le phoneOtpModule est déjà initialisé, on ne le ré-initialise pas
            if ('undefined' === typeof $phoneOtpModule.phoneOtpModule) {
                new PhoneOtpModule($phoneOtpModule);
            }

            $phoneOtpModule.addEventListener('phone_otp_module_success', () => {
                // Si le phoneOtpModule ne concerne pas le partenaire pour lequel on fait l'action, on s'arrête ici
                if (partnerName !== $phoneOtpModule.id) {
                    return;
                }

                this.$button.dispatchEvent(BtnLoadingWaitEvent);
                this.$credentialsContainer.classList.add('hidden');

                postData(scriptVar.ajaxUrl, {
                    action: 'get_clm_partner_credentials',
                    partner_name: this.partnerName,
                }).then(response => {
                    if (response.success) {
                        if (this.$loginContainer) {
                            this.$loginContainer.innerText = response.data.login;
                        }

                        if (this.$passwordContainer) {
                            this.$passwordContainer.innerText = response.data.password;
                        }

                        this.$credentialsContainer.classList.remove('hidden');
                    } else if (this.$errorsContainer) {
                        this.$errorsContainer.innerHTML = `<li>${response.data}</li>`;
                    }

                    this.$button.dispatchEvent(BtnLoadingResetEvent);
                }).catch(error => {
                    console.error(error);

                    this.$button.dispatchEvent(BtnLoadingResetEvent);

                    if (this.$errorsContainer && this.$container.dataset.error) {
                        this.$errorsContainer.innerHTML = `<li>${this.$container.dataset.error}</li>`;
                    }
                });
            });
        }
    }
}
